import { render, staticRenderFns } from "./FPermitTable.vue?vue&type=template&id=178ea36e&scoped=true"
import script from "./FPermitTable.vue?vue&type=script&lang=js"
export * from "./FPermitTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178ea36e",
  null
  
)

export default component.exports